const INTL_LOCALE: Record<string, string> = { fr: 'fr-FR', ar: 'ar-TN', en: 'en-GB' };

/** `2026-10-01T10:00:00.000Z` → « 1 oct. 2026, 11:00 » in the merchant's language and time zone. */
export function formatDateTime(iso: string, locale: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(INTL_LOCALE[locale] ?? 'fr-TN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}
